import { useAuthenticatedUserContext } from "@/context/AuthenticatedUserContext"
import { CollaboratorRole } from "@/domain/collaborator/constants"
import { is_source_mybarnes } from "@/domain/synchro/constants"
import type { ClusterJsonldReadItemClusterItem, UserJsonldRolesItem } from "@/networking/api"
import { isNullOrUndefined } from "@/utils/ts-utils"
import { useCallback } from "react"

export default () => {
  const { user, userInfos } = useAuthenticatedUserContext()

  const hasRole = useCallback((role: UserJsonldRolesItem) => user?.hasRole(role) ?? false, [user])
  const hasRoleGuru = useCallback(() => user?.isGuru ?? false, [user])
  const hasRoleBuAdmin = useCallback(
    (cluster?: string | ClusterJsonldReadItemClusterItem) => {
      if (!(user?.isCollaborator ?? false) || isNullOrUndefined(cluster)) return false

      const clusterId = typeof cluster === "string" ? cluster : cluster.id

      for (const co of userInfos?.collaborators ?? []) {
        if (!is_source_mybarnes(co)) continue
        for (const cl of co.cluster ?? []) {
          if (cl.cluster?.id === clusterId && cl.role?.code === CollaboratorRole.MANAGER)
            return true
        }
      }

      return false
    },
    [user, userInfos]
  )
  const hasSomeRoleBuAdmin = useCallback(() => {
    if (!(user?.isCollaborator ?? false)) return false

    for (const co of userInfos?.collaborators ?? []) {
      if (!is_source_mybarnes(co)) continue
      for (const cl of co.cluster ?? []) {
        if (cl.role?.code === CollaboratorRole.MANAGER) return true
        // console.log(cl.role?.code)
      }
    }

    return false
  }, [user, userInfos])
  const hasRoleCollaborator = useCallback(() => user?.isCollaborator ?? false, [user])
  const hasRoleUser = useCallback(() => user?.isUser ?? false, [user])

  return {
    hasRole,
    hasRoleGuru,
    hasRoleBuAdmin,
    hasSomeRoleBuAdmin,
    hasRoleCollaborator,
    hasRoleUser,
  }
}
